import { AsyncRequest } from 'angieslist-app-platform';
import keymirror from 'keymirror';

export default keymirror({
  ...AsyncRequest.createActionKeys('UPDATE_BUSINESS_DESCRIPTION'),
});



// WEBPACK FOOTER //
// ./src/modules/home/common/welcomeActionKeys.js